import React, {
  useReducer,
  useRef,
  useLayoutEffect,
  useCallback,
  useMemo,
} from "react";
import "./index.scss";
import COLORS from "../../constants/color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendDown,
  faArrowTrendUp,
  faCircle,
} from "@fortawesome/pro-solid-svg-icons";
import Streaming from "../../services/_realtime/price/Streaming";
import NumberFormatter from "../../formatters/NumberFormatter";

const LiveTickerBar = () => {
  const numberFormatter = useMemo(() => new NumberFormatter(), []);
  const streamingRef = useRef(null);
  const streamingUnSub = useRef(null);
  const initialState = [];
  const reducer = (state, action) => {
    switch (action.type) {
      case "SET_DATA":
        return action.data;
      case "UPDATE_DATA": {
        const updatedState = state.map((item) => {
          if (item["@"] === action.data["@"]) {
            return {
              ...item,
              ...action.data,
              dailyChangeColor:
                action.data.dailyChange > 0
                  ? "green"
                  : action.data.dailyChange < 0
                    ? "red"
                    : "grey",
            };
          }
          return item;
        });
        if (!updatedState.find((item) => item["@"] === action.data["@"])) {
          updatedState.push({
            ...action.data,
            dailyChangeColor:
              action.data.dailyChange > 0
                ? "green"
                : action.data.dailyChange < 0
                  ? "red"
                  : "grey",
          });
        }
        return updatedState;
      }
      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const liveTickerBarRawData = useMemo(
    () => [
      {
        "@": "sec.101.409",
        objectId: "sec.101.409",
        name: "BIST 30",
        lastPrice: 0,
        dailyChange: 0,
        dailyChangeColor: "grey",
      },
      {
        "@": "sec.101.411",
        objectId: "sec.101.411",
        name: "BIST 100",
        lastPrice: 0,
        dailyChange: 0,
        dailyChangeColor: "grey",
      },
      {
        "@": "sec.101.29976",
        objectId: "sec.101.29976",
        name: "BIST LIKIT BANKA",
        lastPrice: 0,
        dailyChange: 0,
        dailyChangeColor: "grey",
      },
      {
        "@": "sec.39941.175",
        objectId: "sec.39941.175",
        name: "ABD DOLARI (TRY)",
        lastPrice: 0,
        dailyChange: 0,
        dailyChangeColor: "grey",
      },
      {
        "@": "sec.39941.349",
        objectId: "sec.39941.349",
        name: "EURO (TRY)",
        lastPrice: 0,
        dailyChange: 0,
        dailyChangeColor: "grey",
      },
      {
        "@": "sec.47001.256",
        objectId: "sec.47001.256",
        name: "Altın / ONS",
        lastPrice: 0,
        dailyChange: 0,
        dailyChangeColor: "grey",
      },
    ],
    []
  );

  const processStreamingData = useCallback((msg) => {
    const cmd = msg["@"];
    if (!cmd || cmd === "heartbeat" || cmd === "handshake") return;
    dispatch({ type: "UPDATE_DATA", data: msg });
  }, []);

  useLayoutEffect(() => {
    dispatch({ type: "SET_DATA", data: liveTickerBarRawData });
    if (!streamingRef.current) {
      streamingRef.current = new Streaming();
      streamingUnSub.current = streamingRef.current.subscribe(
        {
          objectIds: [
            "sec.39941.175",
            "sec.39941.349",
            "sec.101.29976",
            "sec.47001.256",
            "sec.101.409",
            "sec.101.411",
          ],
        },
        (data) => {
          processStreamingData(data);
        }
      );
    }
    return () => {
      if (streamingRef.current) {
        streamingUnSub.current.Dispose();
      }
    };
  }, [liveTickerBarRawData, processStreamingData]);

  return (
    <div className="live-ticker-bar">
      {state.map((item) => (
        <div
          className={`live-ticker-bar-item ${item.dailyChangeColor === "red"
            ? "colorRedBg"
            : item.dailyChangeColor === "green"
              ? "colorGreenBg"
              : "colorGreyBg"
            }`}
          key={item.objectId}
        >
          <div className="live-ticker-bar-item-content">
            <div className="item-name">{item.name}</div>
            <div className="item-bottom">
              <div className="item-price">
                {numberFormatter.Double(item.lastPrice, item.objectId === "sec.39941.175" || item.objectId === "sec.39941.349" ? 4 : 2)}
              </div>
              <div
                className={`item-change ${item.dailyChangeColor === "red"
                  ? "red-text"
                  : item.dailyChangeColor === "green"
                    ? "green-text"
                    : "grey-text"
                  }`}
              >
                <FontAwesomeIcon
                  icon={
                    item.dailyChangeColor === "red"
                      ? faArrowTrendDown
                      : item.dailyChangeColor === "green"
                        ? faArrowTrendUp
                        : faCircle
                  }
                  className="change-icon"
                />
                {item.dailyChange > 0 ? "" : ""}
                {numberFormatter.Double(item.dailyChange, item.objectId === "sec.39941.175" || item.objectId === "sec.39941.349" ? 4 : 2)}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default React.memo(LiveTickerBar);
